import { unitLinkLabel } from './UnitLinkSelect';

export const NoteUnitFilter = ({ equipment, value, onChange }) => <div className="mb-4 min-w-0 space-y-1" data-testid="note-unit-filter-container">
  <label htmlFor="note-unit-filter" className="text-xs font-medium text-slate-500">Notes for</label>
  <select id="note-unit-filter" value={value} onChange={(e) => onChange(e.target.value)} className="w-full min-w-0 max-w-full border border-slate-300 rounded-md px-2 py-2 text-sm bg-white" data-testid="note-unit-filter">
    <option value="all" data-testid="note-unit-filter-all">All notes</option>
    {equipment.map((item, index) => <option key={item.id} value={item.id} data-testid={`note-unit-filter-${item.id}`}>{unitLinkLabel(item, index)}</option>)}
    <option value="general" data-testid="note-unit-filter-general">General / previous assets</option>
  </select>
</div>;